// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  shotId: __t.u64().primaryKey().name("shot_id"),
  cityId: __t.u64().name("city_id"),
  turretStructureId: __t.u64().name("turret_structure_id"),
  targetKind: __t.string().name("target_kind"),
  targetId: __t.u64().name("target_id"),
  targetX: __t.f32().name("target_x"),
  targetZ: __t.f32().name("target_z"),
  damage: __t.u32(),
  at: __t.timestamp(),
});
